import angular, { IPromise } from 'angular'
import { RetailerLoyaltySettings } from '../../queries/loyalty-threshold'
import { $q } from '../../ng-compat/imports'
import { EntityStore } from './entity-store'

const LOYALTY_SETTINGS = 'LOYALTY_SETTINGS'

export class LoyaltySettingsStore extends EntityStore<'settings'> {
  constructor() {
    'ngInject'
    super({
      entityName: 'loyalty',
      entityStoreName: 'loyaltySettings',
      databaseStoreName: 'settings',
    })
  }

  /**
   * Get the retailers loyalty settings from the IndexedDB store.
   *
   * @return A promise resolved with the loyalty settings
   */
  public get(): IPromise<RetailerLoyaltySettings> {
    return super.get(LOYALTY_SETTINGS)
  }

  /**
   * Sync the given retailer loyalty settings data to the IndexedDB store.
   *
   * @param  {RetailerLoyaltySettings} [data] The retailer's loyalty settings as returned by the GraphQL API call (in an array of length one).
   *
   * @return A promise resolved once the given retailer loyalty settings data has been synced with the IndexedDB store
   *
   */
  public syncData(data: RetailerLoyaltySettings[]) {
    const loyaltySettings = data && data[0]

    if (!loyaltySettings) {
      return $q.reject(
        new Error('Invalid loyalty settings data: settings object is required')
      )
    }

    return this.dbStore.put(LOYALTY_SETTINGS, loyaltySettings).then(() =>
      this.emitSyncEvent({
        removed: [],
        updated: [loyaltySettings],
      })
    )
  }
}

export const loyaltySettingsStore = new LoyaltySettingsStore()

angular
  .module('webregister.factories')
  .constant('loyaltySettingsStore', loyaltySettingsStore)
